import { IPhotoRequestsNormalized } from '../api/models/photoRequests/photoRequests.types';
import { ActionsUnion, createAction } from '../helpers';
import {
  IAnswerPhotoRequestPayload,
  IAnswerPhotoRequestSuccessPayload,
  IPostPhotoRequestPayload,
} from './types';

export enum EPhotoRequestsActionType {
  ANSWER_PHOTO_REQUEST = 'PHOTO_REQUESTS/ANSWER_PHOTO_REQUEST',
  ANSWER_PHOTO_REQUEST_SUCCESS = 'PHOTO_REQUESTS/ANSWER_PHOTO_REQUEST_SUCCESS',
  GET = 'PHOTO_REQUESTS/GET',
  GET_SUCCESS = 'PHOTO_REQUESTS/GET_SUCCESS',
  RESET = 'PHOTO_REQUESTS/RESET',
  POST = 'PHOTO_REQUESTS/POST',
  POST_SUCCESS = 'PHOTO_REQUESTS/POST_SUCCESS',
}

export const photoRequestsAction = {
  getPhotoRequests: (reset: boolean) =>
    createAction(EPhotoRequestsActionType.GET, { reset }),
  getPhotoRequestsSuccess: (payload: IPhotoRequestsNormalized) =>
    createAction(EPhotoRequestsActionType.GET_SUCCESS, payload),
  resetPhotoRequests: () => createAction(EPhotoRequestsActionType.RESET),
  answerPhotoRequest: (payload: IAnswerPhotoRequestPayload) =>
    createAction(EPhotoRequestsActionType.ANSWER_PHOTO_REQUEST, payload),
  answerPhotoRequestSuccess: (payload: IAnswerPhotoRequestSuccessPayload) =>
    createAction(
      EPhotoRequestsActionType.ANSWER_PHOTO_REQUEST_SUCCESS,
      payload
    ),
  postPhotoRequest: (payload: IPostPhotoRequestPayload) =>
    createAction(EPhotoRequestsActionType.POST, payload),
  postPhotoRequestSuccess: ({ receiverId }: { receiverId: string }) =>
    createAction(EPhotoRequestsActionType.POST_SUCCESS, { receiverId }),
};

export type TPhotoRequestsAction = ActionsUnion<typeof photoRequestsAction>;
